import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      '& .MuiDialog-paper': {
        maxWidth: theme.spacing(60),
        borderRadius: theme.spacing(1),
      },
    },
    wrapper: {
      padding: theme.spacing(3),
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(2),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: theme.spacing(1),
    },
    icon: {
      fontSize: theme.spacing(6),
    },
    contentText: {
      textAlign: 'center',
      color: theme.palette.text.primary,
      whiteSpace: 'pre-wrap',
    },
    actions: {
      justifyContent: 'flex-end',
      gap: theme.spacing(1.5),
      padding: theme.spacing(2, 3),
    },
  })
);
